import { useEffect, useRef, useState } from "react";
import { apiFetch } from "../../../app/apiClient";
import { useAppDispatch, useAppSelector } from "../../../app/hooks";
import ComponentLoading from "../../../components/ComponentLoading";
import { currentToken } from "../../login/loginSlice";
import { activeFolder, loadEmail } from "../emailSlice";
import EmailMessageItem from "./EmailMessageItem";

export interface EmailMessageType {
    key: string;
    from: string;
    subject: string;
    date: string;
}

function populateMessages(messages: EmailMessageType[], dispatchObject: any) {
    return <>{
        messages.map((message) => {
            return <EmailMessageItem message={message} key={message.key} onClick={() => {dispatchObject(loadEmail(message.key))}} />
        })
    }</>;
}

function FolderContents() {
    let dispatch = useAppDispatch();
    let [contents, setContents] = useState(<span>Loading...</span>);
    let [currentLoadingEvents, setCurrentLoadingEvents] = useState(0);
    let targetFolder = useAppSelector(activeFolder);
    let userToken = useAppSelector(currentToken);
    // Tracks which folder's data is currently rendered, so the effect only
    // refetches when targetFolder actually changes, not on every render.
    let loadedFolderRef = useRef<string | null>(null);

    useEffect(() => {
        if (loadedFolderRef.current === targetFolder) {
            return;
        }
        const abortController = new AbortController();

        async function loadFolderData() {
            setCurrentLoadingEvents((count) => count + 1);
            setContents(<span>Loading...</span>);
            try {
                const response = await apiFetch("/api/emails/" + targetFolder, {
                    method: "GET",
                    token: userToken,
                    signal: abortController.signal
                });
                const folderData = await response.json();
                loadedFolderRef.current = targetFolder;
                if (folderData.messages.length > 0) {
                    setContents(populateMessages(folderData.messages, dispatch));
                } else {
                    setContents(<span>Empty...</span>);
                }
            } catch (error: any) {
                if (error.name !== "AbortError") {
                    setContents(<span>Failed to load folder.</span>);
                }
            } finally {
                setCurrentLoadingEvents((count) => count - 1);
            }
        }

        loadFolderData();
        return () => abortController.abort();
    }, [targetFolder, userToken, dispatch]);

    return(<div className={"folderContents"}>
        <ComponentLoading isActive={currentLoadingEvents > 0} />
        <h2>{targetFolder?.toUpperCase()}</h2>
        {contents}
    </div>);
}

export default FolderContents;